import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ArrHlp } from 'src/lib/fliko/helpers/array.helper';
import { FileInStorageHlp } from '../../helpers/file.helper';
import { FileInStorageData } from '../../models/file.data';
import { FireStorageService } from '../../services/storage.service';

@Component({
  selector: 'app-attachment-list-in-view',
  templateUrl: './attachment-list-in-view.component.html',
  styleUrls: ['./attachment-list-in-view.component.scss']
})
export class AttachmentListInViewComponent implements OnChanges {
  @Input() attachments: FileInStorageData[] = [];
  @Input() attachmentSliceLength: number = -1;
  @Input() showFileSize: boolean = true;

  @Output() onEdit = new EventEmitter<number>();
  @Output() onDelete = new EventEmitter<number>();

  public attWithSize: FileInStorageData[] = [];

  constructor(private storageService: FireStorageService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.attachments && this.showFileSize) {
      const prevAtt: FileInStorageData[] = changes.attachments.previousValue || [];
      const currAtt: FileInStorageData[] = changes.attachments.currentValue || [];
      if (ArrHlp.checkDifferences(currAtt, prevAtt, FileInStorageHlp.areEqual) == currAtt.length) this.attWithSize = [];

      this.attWithSize = await FileInStorageHlp.copyAndAppendFiles(
        changes.attachments.currentValue,
        this.attWithSize,
        this.storageService
      );
    }
  }

  public get fileData(): FileInStorageHlp[] {
    return this.showFileSize ? this.attWithSize : this.attachments;
  }

  public delete(event: Event, index: number): void {
    event.stopImmediatePropagation();
    this.onDelete.emit(index);
  }

  public download(attachment: FileInStorageData): void {
    this.storageService.getDownloadURL(attachment.storagePath).then((url) => window.open(url, '_blank'));
  }
}
